import { z } from "zod";

export const toggleReactionSchema = z.object({
	emoji: z.string().min(1).max(10),
});

export type ToggleReactionPayload = z.infer<typeof toggleReactionSchema>;
